import { useSetAtom } from "jotai";
import {
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";
import { usePriceListState } from "atoms/priceListAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeletePriceListItem } from "./api";

export const PricelistFooter = (): JSX.Element => {
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { priceListState, setPriceListState } = usePriceListState();

  const { mutate: deletePriceListItem } = useDeletePriceListItem();

  const onConfirm = () => {
    deletePriceListItem(priceListState.activeItem?.pricelistid || "");
    closeModal();
  };

  const handleClickAdd = () => {
    setPriceListState({ activeItem: null });
  };

  const handleDeleteClick = () => {
    if (priceListState.activeItem) {
      setConfirmationModal({
        title: `Вы действительно хотите удалить прайс лист "${priceListState.activeItem.name}" ?`,
        onConfirm,
      });
    }
  };

  const handleCopyClick = () => {
    // @ts-ignore
    setPriceListState((prev) => ({
      ...prev,
      activeItem: {
        ...prev.activeItem,
        pricelistid: undefined,
        name: prev.activeItem?.name + "_copy",
      },
    }));
  };

  return (
    <div className="flex flex-row ">
      <Button icon="plus" onClick={handleClickAdd} />
      <HorizontalSpace size={11} />
      <Button
        icon="delete"
        onClick={handleDeleteClick}
        disabled={!priceListState.activeItem}
      />
      <HorizontalSpace size={11} />
      <Button
        icon="copy"
        onClick={handleCopyClick}
        disabled={!priceListState.activeItem}
      >
        Копировать
      </Button>
    </div>
  );
};
